export default __webpack_public_path__ + "static/media/img01.ca18978e.svg";